export default {
  '0': '成功',
  '1': '校验参数失败',
  '2': '未扫码',
  '7': '参数校验失败',
  '402': '过期',
  '403': '用户取消授权',
  '404': '扫码成功，用户未授权',
  '405': '用户授权完毕',
  '408': '等待',
  '10000': '用户未登录',
  '10001': '用户不存在',
  '10003': '用户名或密码错误',
  '10005': '注册失败',
  '10006': '该邮箱已被使用',
  '10007': '新旧密码相同',
  '10008': '您不是会员，请先注册',
  '10009': '两次输入密码不一致',
  '10010': '邮箱格式不正确',
  '10011': '用户登录超时',
  '10012': '原密码不正确',
  '10013': '邮箱不能为空',
  '10014': '密码不能为空',
  '10015': '已过有效期',
  '10016': '验证码已超过5次',
  '10017': '验证码错误',
  '10020': '用户被冻结或已被注销',
  '10021': '手机号码长度不能超过20个字符',
  '10022': '邮箱长度不能超过50个字符',
  '10023': '昵称长度不能超过50个字符',
  '10024': '用户名长度不能超过50个字符',
  '10025': '密码长度不能超过20个字符',
  '10026': '平台参数错误',
  '10029': '验证码不能为空',
  '10031': '该账号操作过于频繁，已被禁用',
  '10036': '手机或邮箱格式不正确',
  '10037': '验证码保存时出错',
  '10045': '手机已被使用',
  '10047': '该邮箱未绑定',
  '10048': '该手机未绑定',
  '10050': '用户名过长',
  '10056': '昵称不能包含敏感词',
  '10101': '微信授权过期',
  '10103': '微信获取用户信息失败',
  '10104': '账号已经被微信绑定',
  '10106': '该账号已被使用',
  '20002': '超过验证码发送次数',
  '20004': '您已验证，无需重复',
  '20005': '验证码错误：请填写您当时核对成功的验证码',
}
